import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CityResponse,
  CouncilResponse,
  ProfessionalQualificationResponse,
  SpecializationResponse,
  StateResponse,
} from '@app/core.model';
import { ClinicResponse } from '@features/managed-clinic/managed-clinic.model';
import { medicalProfileResponse } from '@features/masters/masters.model';
import { environment } from 'src/environments/environment';

import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root',
})
export class SharedMastersService {
  constructor(private http: HttpClient, private commonService: CommonService) {}

  getCityList(filter?: string) {
    let url = `${environment.baseAPIUrl}/masters/cities`;
    if (filter?.length) {
      url += `filter=${filter}`;
    }
    return this.http.get<CityResponse>(url, {
      headers: this.commonService.getRequestHeaders(),
    });
  }

  getCityListByStateId(id: string, filter?: string) {
    let url = `${environment.baseAPIUrl}/masters/states/${id}/cities`;
    if (filter?.length) {
      url += `filter=${filter}`;
    }
    return this.http.get<CityResponse>(url, {
      headers: this.commonService.getRequestHeaders(),
    });
  }

  getStateList(filter?: string) {
    let url = `${environment.baseAPIUrl}/masters/states`;
    if (filter?.length) {
      url += `filter=${filter}`;
    }
    return this.http.get<StateResponse>(url, {
      headers: this.commonService.getRequestHeaders(),
    });
  }

  getCouncilList(filter?: string) {
    let url = `${environment.baseAPIUrl}/masters/doctors/councils`;
    if (filter?.length) {
      url += `filter=${filter}`;
    }
    return this.http.get<CouncilResponse>(url, {
      headers: this.commonService.getRequestHeaders(),
    });
  }

  getProfessionalQualificationList(filter?: string) {
    let url = `${environment.baseAPIUrl}/masters/doctors/qualifications`;
    if (filter?.length) {
      url += `filter=${filter}`;
    }
    return this.http.get<ProfessionalQualificationResponse>(url, {
      headers: this.commonService.getRequestHeaders(),
    });
  }

  getSpecializationList(filter?: string) {
    let url = `${environment.baseAPIUrl}/masters/doctors/specializations`;
    if (filter?.length) {
      url += `filter=${filter}`;
    }
    return this.http.get<SpecializationResponse>(url, {
      headers: this.commonService.getRequestHeaders(),
    });
  }

  getMedicalProfileList(type: number, filter?: string) {
    let url = `${environment.baseAPIUrl}/medical-profiles?type=${type}`;
    if (filter?.length) {
      url += `filter=${filter}`;
    }
    return this.http.get<medicalProfileResponse>(url, {
      headers: this.commonService.getRequestHeaders(),
    });
  }

  getClinicList() {
    const url = `${environment.baseAPIUrl}/v2/clinics`;
    return this.http.get<ClinicResponse>(url, {
      headers: this.commonService.getRequestHeaders(),
    });
  }
}
